import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import app from '@/store/app'
import appConfig from '@/store/app-config'
import verticalMenu from '@/store/vertical-menu'
/* Dashboard */
import dashboard from '@/store/Reports/dashboard'
import liveSalesDashboard from '@/store/Reports/liveSales'
import liveI2SalesDashboard from '@/store/Reports/liveI2Sales'
import liveInsurancesDashboard from '@/store/Reports/liveInsurances'
import liveCrmDashboard from '@/store/Reports/liveCrm'
import liveRealtySalesDashboard from '@/store/Reports/liveRealtySales'
import liveServiceDashboard from '@/store/Reports/liveService'
import liveDashboardConfig from '@/store/Reports/liveConfig'
/* Sıfır Satış */
import saleOverviews from '@/store/Reports/sales/overviews'
import saleReports from '@/store/Reports/sales/sales'
import saleSwapsReports from '@/store/Reports/sales/swaps'
import saleInterviewsReports from '@/store/Reports/sales/interviews'
import saleCustomersReports from '@/store/Reports/sales/customers'
import saleGoalsReports from '@/store/Reports/sales/goals'
import saleStocksReports from '@/store/Reports/sales/stocks'
/* 2. El */
import i2SalesOverviewsReports from '@/store/Reports/i2Sales/overviews'
import i2SalesReports from '@/store/Reports/i2Sales/sales'
import i2SaleSwapsReports from '@/store/Reports/i2Sales/swaps'
/* Müşteri Deneyimi */
import crmOverviewsReports from '@/store/Reports/crm/overviews'
import crmComplaintsReports from '@/store/Reports/crm/complaints'
import crmSubjectsReports from '@/store/Reports/crm/subjects'
import crmCsiReports from '@/store/Reports/crm/csi'
/* Sigorta */
import insuranceSalesReports from '@/store/Reports/insurances/sales'
import insuranceRenewalsReports from '@/store/Reports/insurances/renewals'
import insuranceBranchesReports from '@/store/Reports/insurances/branches'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,
    dashboard,
    liveSalesDashboard,
    liveI2SalesDashboard,
    liveInsurancesDashboard,
    liveCrmDashboard,
    liveRealtySalesDashboard,
    liveServiceDashboard,
    saleOverviews,
    saleReports,
    saleSwapsReports,
    saleInterviewsReports,
    saleCustomersReports,
    saleGoalsReports,
    saleStocksReports,
    i2SalesOverviewsReports,
    i2SalesReports,
    i2SaleSwapsReports,
    crmOverviewsReports,
    crmComplaintsReports,
    crmSubjectsReports,
    crmCsiReports,
    insuranceSalesReports,
    insuranceRenewalsReports,
    insuranceBranchesReports,
    liveDashboardConfig,
  },
  strict: process.env.DEV,
})
